import React, { useContext } from 'react'

import COMPANIES_WITHOUT_DELIVERY_PROMISE from '../../constants/companies'
import { STATUS_STEP_TITLES } from '../../constants/trackingTexts'
import { DataContext } from '../../context/DataContext'

import DeliveryState from './MappedStates/DeliveryState'
import DeliveryEvidence from './MappedStates/DeliveryEvidence'
import TrackingMap from './MappedStates/TrackingMap'
import DiscountBar from './MappedStates/DiscountBar'

const StatusMapperComponent: React.FC = () => {
  const { sale } = useContext(DataContext)

  const statusIndex = STATUS_STEP_TITLES[sale?.packageStatus as keyof typeof STATUS_STEP_TITLES]

  const showDeliveryPromise =
    sale.managedByPinflag &&
    !COMPANIES_WITHOUT_DELIVERY_PROMISE.includes(String(sale.companyId))

  return (
    <div>
      {(statusIndex === 1 || statusIndex === 2) && (
        showDeliveryPromise ? <DeliveryState /> : <div className='h-5' />
      )}
      {statusIndex === 2 &&
        sale.deliveryType !== 'storePickup' &&
        (
        <TrackingMap />
      )}
      {statusIndex === 3 && (
        sale.managedByPinflag ? <DiscountBar /> : <div className='h-5' />
      )}
      {statusIndex === 4 && (
        <DeliveryEvidence />
      )}
    </div>
  )
}

export default StatusMapperComponent
